import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer, PURGE } from 'redux-persist';
import persistConfig from 'persist';
import authReducer from 'store/auth/authSlice';
import orderReducer from 'store/orders/ordersSlice';
import productReducer from 'store/products/productsSlice';
import categoryReducer from 'store/categories/categoriesSlice';
import userReducer from 'store/users/userSlice';
import offerReducer from 'store/offers/offersSlice';
import reviewReducer from 'store/reviews/reviewsSlice';
import advertisementReducer from 'store/advertisements/advertisementsSlice';
import landingImageReducer from 'store/landing-images/landingSlice';
import rolesReducer from 'store/roles/roleSlice';
import subscriptionsReducer from 'store/subscriptions/subscriptionsSlice';
import inquiriesReducer from 'store/inquiries/inquirySlice';
import stateReducer from 'store/state/stateSlice';
import settingReducer from 'store/settings/settingSlice';
import dashboardReducer from 'store/dashboard/dashboardSlice';
import couponsReducer from 'store/coupons/couponSlice';

const appReducer = combineReducers({
  auth: persistReducer(persistConfig, authReducer),
  order: orderReducer,
  product: productReducer,
  category: categoryReducer,
  user: userReducer,
  offer: offerReducer,
  review: reviewReducer,
  advertisement: advertisementReducer,
  landing: landingImageReducer,
  role: rolesReducer,
  subscription: subscriptionsReducer,
  inquiry: inquiriesReducer,
  state: stateReducer,
  setting: settingReducer,
  dashboard: dashboardReducer,
  coupon: couponsReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === PURGE) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
